module.exports = __webpack_public_path__ + "img/366-7521a7.png";